import split from 'lodash/split'
import addTrailingSlash from 'utils/addTrailingSlash'

const splitURLPath = fullPath => {
  const separatorChar = fullPath.includes('#') ? '#' : '?'
  const [path, hash] = split(fullPath, separatorChar)
  return [path, hash, separatorChar]
}

export default fullPath => {
  if (!fullPath) return '/'
  const [path, hash, separatorChar] = splitURLPath(fullPath)

  return `${addTrailingSlash(path)}${hash ? `${separatorChar}${hash}` : ''}`
}
